import React, { useCallback } from 'react';
import Select from '@components/shared/ui/Select';
import { warehouseZoneService } from '@services/operator/warehouseZoneService';

const WarehouseZoneSelect = (props) => {
  const fetchZones = useCallback(async ({ search, sinceId, pageSize }) => {
    try {
      const params = {
        page_size: pageSize,
        since_id: sinceId,
        search: search
      };

      const response = await warehouseZoneService.getRecords(params);
      
      if (response.success) {
        return {
          options: response.data.map(zone => ({
            label: zone.name,
            value: zone.id
          })),
          hasMore: response.has_more,
          sinceId: response.since_id
        };
      }
      return { options: [], hasMore: false, sinceId: null };
    } catch (error) {
      console.error('Failed to fetch warehouse zones:', error);
      return { options: [], hasMore: false, sinceId: null };
    }
  }, []);

  return (
    <Select
      placeholder="請選擇區域"
      fetchData={fetchZones}
      pageSize={50}
      isSearchable
      {...props}
    />
  );
};

export default WarehouseZoneSelect;
